import React, { useState, useEffect } from "react";
import "./statusDropdown.css";
import CricleCross from "../../Assets/Icons/circle-x-filled.png";
import { useTranslation } from "react-i18next";

const StatusDropdown = ({ statusTypes, onStatusChange, setShowFilter, selectedStatuses, setSelectedStatuses }) => {
  const [isWide, setIsWide] = useState(false);
  const [action, setAction] = useState(null);
  const { t } = useTranslation();

  const statusLabelMap = {
    OPEN: `${t("open")}`,
    IN_REVIEW: `${t("inReview")}`,
    REJECTED: `${t("rejected")}`,
    QUOTED: `${t("quoted")}`,
    PAID: `${t("PAID")}`,
    PENDING: `${t("PENDING")}`,
    IN_PROGRESS: `${t("IN_PROGRESS")}`,
    CANCELLED: `${t("CANCELLED")}`,
    COMPLETED: `${t("COMPLETED")}`,
  };

  useEffect(() => {
    setIsWide(statusTypes.length > 5);
  }, [statusTypes.length]);

  const handleCheckboxChange = (status) => {
    setSelectedStatuses((prevSelected) => {
      const newSelected =
        prevSelected && prevSelected.includes(status) ? prevSelected.filter((s) => s !== status) : [...(prevSelected || []), status];
      setAction("select");
      return newSelected.length > 0 ? newSelected : null;
    });
  };

  const handleSelectAll = () => {
    setSelectedStatuses(statusTypes);
    setAction("selectAll");
  };

  const handleClearAll = () => {
    setSelectedStatuses(null);
    setAction("clearAll");
  };

  useEffect(() => {
    if (action) {
      onStatusChange(selectedStatuses);
    }
  }, [selectedStatuses, onStatusChange, action]);

  const getGridClass = (count) => {
    if (count <= 1) return "columns-1";
    if (count <= 2) return "columns-2";
    if (count <= 3) return "columns-3";
    if (count <= 4) return "columns-4";
    return "columns-5";
  };

  return (
    <div className={`sd-dropdown ${isWide ? "wide" : ""}`}>
      <div className="sd-header">
        <section className="sd-title">{t("filterByStatus")}</section>
        <section className="sd-close" onClick={() => setShowFilter(false)} aria-label="Close filter">
          <img src={CricleCross} alt="X" />
        </section>
      </div>
      <p className="sd-description">{t("selectCriteriaFilter")}</p>
      <div className={`sd-options ${getGridClass(statusTypes.length)}`}>
        {statusTypes.map((status) => (
          <div key={status} className="sd-option">
            <input
              type="checkbox"
              id={status}
              checked={selectedStatuses?.includes(status) || false}
              onChange={() => handleCheckboxChange(status)}
              aria-label={`Filter by ${statusLabelMap[status]}`}
            />
            <label htmlFor={status}>{statusLabelMap[status]}</label>
          </div>
        ))}
      </div>
      <div className="sd-actions">
        <section className="sd-action" onClick={handleSelectAll} aria-label="Select all statuses">
          {t("selectAll")}
        </section>
        <section className="sd-action" onClick={handleClearAll} aria-label="Clear all statuses">
          {t("clear")}
        </section>
      </div>
    </div>
  );
};

export default StatusDropdown;
